export enum OfferAssistantNotificationType {
  FullOfferInfo = 1,
  ConfirmedOffer = 2
}

(OfferAssistantNotificationType as any).__typeName = 'OfferAssistantNotificationType';